(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6824],{

/***/ 29434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ PhotoCarousel; },
  "r": function() { return /* binding */ PhotoCarouselAspectRatios; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(22805);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(63988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Text/index.js
var Text = __webpack_require__(24404);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(41538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/Text.js
var Text_Text = __webpack_require__(35934);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(65620);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarouselDots.js






var PhotoCarouselDots_image = Components/* tokens.image */.T.image, DOT_HEIGHT = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.height), ACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.width), INACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.other), DOT_MARGIN = 3, VISIBLE_DOTS = 5, PhotoCarouselDots = function(param) {
    var length = param.length, currentIndex = param.currentIndex;
    var animatedValues = (0,react.useRef)(Array(length).fill(0).map(function() {
        return new Animated/* default.Value */.Z.Value(0);
    }));
    return (0,react.useEffect)(function() {
        animatedValues.current.forEach(function(value, index) {
            Animated/* default.timing */.Z.timing(value, {
                toValue: index === currentIndex ? 1 : 0,
                duration: 300,
                useNativeDriver: !1
            }).start();
        });
    }, [
        currentIndex
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        children: function() {
            var start = Math.max(0, Math.min(currentIndex - 2, length - VISIBLE_DOTS)), end = Math.min(start + VISIBLE_DOTS, length);
            return Array(length).fill(0).slice(start, end).map(function(_, index) {
                var realIndex = start + index, width = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        INACTIVE_DOT_WIDTH,
                        ACTIVE_DOT_WIDTH
                    ]
                }), opacity = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        0.5,
                        1
                    ]
                });
                return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    "data-testid": "photo-carousel-dot-".concat(realIndex),
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                        style: [
                            styles.dot,
                            {
                                width: width,
                                opacity: opacity
                            }
                        ]
                    })
                }, realIndex);
            });
        }()
    });
}, styles = StyleSheet/* default.create */.Z.create({
    dot: {
        height: DOT_HEIGHT,
        backgroundColor: "white",
        borderRadius: DOT_HEIGHT / 2,
        marginHorizontal: DOT_MARGIN
    }
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarousel.js











var DEFAULT_ASPECT_RATIO = 16 / 9, SQUARE_ASPECT_RATIO = 1 / 1;
var PhotoCarouselAspectRatios = /* @__PURE__ */ function(PhotoCarouselAspectRatios2) {
    return PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.DEFAULT = DEFAULT_ASPECT_RATIO] = "DEFAULT", PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.SQUARE = SQUARE_ASPECT_RATIO] = "SQUARE", PhotoCarouselAspectRatios2;
}(PhotoCarouselAspectRatios || {});
var PhotoCarousel = function(param) {
    var photos = param.photos, children = param.children, ariaLabel = param.ariaLabel, hideNavigation = param.hideNavigation, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? PhotoCarouselAspectRatios.DEFAULT : _aspectRatio, _height = param.height, height = _height === void 0 ? "100%" : _height, _isRounded = param.isRounded, isRounded = _isRounded === void 0 ? !1 : _isRounded;
    var ref = (0,react.useState)(0), currentImageIndex = ref[0], setCurrentImageIndex = ref[1], ref1 = (0,react.useState)(0), containerWidth = ref1[0], setContainerWidth = ref1[1], ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), navigationMessagePosition = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, ref3 = (0,react.useState)(!1), showNavigationMessage = ref3[0], setShowNavigationMessage = ref3[1], useNativeDriver = Platform/* default.OS */.Z.OS !== "web", onLayout = function(event) {
        var width = event.nativeEvent.layout.width;
        setContainerWidth(width);
    };
    (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(navigationMessagePosition, {
            toValue: showNavigationMessage ? -65 : 0,
            duration: 300,
            easing: Easing/* default.ease */.Z.ease,
            useNativeDriver: useNativeDriver
        }).start();
    }, [
        navigationMessagePosition,
        showNavigationMessage,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var threshold = containerWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photos.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * containerWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: useNativeDriver
                }).start(function() {
                    setCurrentImageIndex(newIndex), currentOffset.current = -newIndex * containerWidth;
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: useNativeDriver
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        containerWidth,
        photos.length,
        offsetX,
        currentImageIndex,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-currentImageIndex * containerWidth), currentOffset.current = -currentImageIndex * containerWidth;
    }, [
        currentImageIndex,
        containerWidth,
        offsetX
    ]);
    var renderImages = function() {
        return photos.map(function(photo, index) {
            return index >= currentImageIndex - 2 && index <= currentImageIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": index !== currentImageIndex,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    source: {
                        uri: photo.url
                    },
                    alt: photo.alt || "Image ".concat(index + 1),
                    width: "100%",
                    height: "100%"
                })
            }, index) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": !0
            }, index);
        });
    }, handlePrev = (0,react.useCallback)(function() {
        currentImageIndex > 0 && setCurrentImageIndex(currentImageIndex - 1);
    }, [
        currentImageIndex
    ]), handleNext = (0,react.useCallback)(function() {
        currentImageIndex < photos.length - 1 && setCurrentImageIndex(currentImageIndex + 1);
    }, [
        currentImageIndex,
        photos.length
    ]);
    (0,react.useEffect)(function() {
        if (!cjs.isWeb) return;
        var handleKeyDown = function(event) {
            event.key === "ArrowLeft" ? handlePrev() : event.key === "ArrowRight" && handleNext(), showNavigationMessage && setShowNavigationMessage(!1);
        }, carouselContainer = carouselRef.current;
        return carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.addEventListener("keydown", handleKeyDown), function() {
            carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleNext,
        handlePrev,
        showNavigationMessage
    ]);
    var atStart = currentImageIndex === 0, atEnd = currentImageIndex === photos.length - 1;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        role: "region",
        "aria-label": ariaLabel || "Photo Carousel",
        tabIndex: 0,
        ref: carouselRef,
        onFocus: function(event) {
            document.activeElement === carouselRef.current && event.relatedTarget !== null && (setShowNavigationMessage(!0), setTimeout(function() {
                setShowNavigationMessage(!1);
            }, 3e3));
        },
        "data-testid": "photo-carousel",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                accessibilityRole: "text",
                accessible: !1,
                style: {
                    position: "absolute",
                    width: 0,
                    height: 0,
                    overflow: "hidden"
                },
                children: [
                    "This is an photo carousel of the property. Swipe left or right to navigate through the photos.",
                    " ",
                    !hideNavigation && "Alternatively, use the next and previous buttons to move between photos."
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "100%",
                onLayout: onLayout
            }, panResponder && panResponder.panHandlers), {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    aspectRatio: aspectRatio,
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    height: height,
                    borderTopLeftRadius: isRounded ? "$16x" : void 0,
                    borderTopRightRadius: isRounded ? "$16x" : void 0,
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                flexDirection: "row",
                                width: containerWidth * photos.length,
                                height: "100%",
                                transform: [
                                    {
                                        translateX: offsetX
                                    }
                                ]
                            },
                            children: renderImages()
                        }),
                        cjs.isWeb && !hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !atStart && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    left: "$10x",
                                    analyticsName: "",
                                    onPress: handlePrev,
                                    "aria-label": "Previous photo",
                                    "data-testid": "chevron-back-button"
                                }),
                                !atEnd && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    right: "$10x",
                                    analyticsName: "",
                                    onPress: handleNext,
                                    "aria-label": "Next photo",
                                    "data-testid": "chevron-forward-button"
                                })
                            ]
                        }) : null,
                        children,
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            position: "absolute",
                            bottom: "$10x",
                            width: containerWidth,
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "center",
                            "data-testid": "photo-carousel-dots",
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PhotoCarouselDots, {
                                length: photos.length,
                                currentIndex: currentImageIndex
                            })
                        }),
                        hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                position: "absolute",
                                bottom: -30,
                                left: 0,
                                right: 0,
                                justifyContent: "center",
                                flexDirection: "row",
                                transform: [
                                    {
                                        translateY: navigationMessagePosition
                                    }
                                ]
                            },
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Text_Text/* Text */.xv, {
                                backgroundColor: "$backgroundInversePrimary",
                                color: "$backgroundPrimary",
                                paddingHorizontal: "$4x",
                                paddingVertical: "$2x",
                                borderRadius: "$10x",
                                typography: "$bodySmall",
                                opacity: 0.7,
                                children: "Use arrow keys to navigate"
                            })
                        }) : null
                    ]
                })
            }))
        ]
    });
};



/***/ }),

/***/ 53757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12554);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61274);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);








var BoxWithRgbaBackground = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
    variants: {
        backgroundColorVariant: function(variant) {
            var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill;
            return variant !== "inverse" ? {
                backgroundColor: pillTokens.color.background[variant]
            } : {
                backgroundColor: (0,_helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getTokenValue)(pillTokens.color.background.default, "color"), (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_5__/* .getOpacityTokenValue */ .vs)(pillTokens.opacity.backgroundInverse))
            };
        }
    }
}), Pill = function(_param) {
    var label = _param.label, rounded = _param.rounded, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _weight = _param.weight, weight = _weight === void 0 ? "regularWeight" : _weight, dataTestId = _param["data-testid"], props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label",
        "rounded",
        "variant",
        "weight",
        "data-testid"
    ]);
    var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill, ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.useProps)(props), _size = ref.size, size = _size === void 0 ? "medium" : _size, sizeToken = size === "xsmall" ? "small" : size;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithRgbaBackground, {
        alignItems: "center",
        justifyContent: "center",
        backgroundColorVariant: variant,
        borderColor: pillTokens.color.border[variant],
        borderRadius: rounded ? pillTokens.cornerRadius.rounded : pillTokens.cornerRadius[sizeToken],
        borderWidth: pillTokens.borderWidth.default,
        height: size === "xsmall" ? "auto" : pillTokens.size.height[weight]["".concat(sizeToken, "Size")],
        paddingBottom: size === "medium" ? pillTokens.padding.medium.bottom[weight] : pillTokens.padding.small.topBottom[weight],
        paddingHorizontal: pillTokens.padding[sizeToken].rightLeft,
        paddingTop: size === "medium" ? pillTokens.padding.medium.top[weight] : pillTokens.padding.small.topBottom[weight],
        width: "max-content",
        "data-testid": dataTestId,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
            tag: "span",
            typography: size === "xsmall" ? "$bodyXsmall" : pillTokens.typography[weight][size],
            fontWeight: weight === "mediumWeight" ? "$medium" : "$regular",
            color: pillTokens.color.content.label[variant === "black" ? "inverse" : variant],
            children: label
        })
    });
};



/***/ }),

/***/ 73503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ Lightbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(41682);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(53089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(64645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(63988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(13145);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';


function isScreenReaderEnabled() {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
}
var prefersReducedMotionMedia = canUseDom/* default */.Z && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
function isReduceMotionEnabled() {
  return new Promise((resolve, reject) => {
    resolve(prefersReducedMotionMedia ? prefersReducedMotionMedia.matches : true);
  });
}
function addChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.addEventListener != null ? prefersReducedMotionMedia.addEventListener('change', fn) : prefersReducedMotionMedia.addListener(fn);
  }
}
function removeChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.removeEventListener != null ? prefersReducedMotionMedia.removeEventListener('change', fn) : prefersReducedMotionMedia.removeListener(fn);
  }
}
var handlers = {};
var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isScreenReaderEnabled,
  /**
   * Query whether the user prefers reduced motion.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isReduceMotionEnabled,
  /**
   * Deprecated
   */
  fetch: isScreenReaderEnabled,
  /**
   * Add an event handler. Supported events: reduceMotionChanged
   */
  addEventListener: function addEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      if (!prefersReducedMotionMedia) {
        return;
      }
      var listener = event => {
        handler(event.matches);
      };
      addChangeListener(listener);
      handlers[handler] = listener;
    }
    return {
      remove: () => AccessibilityInfo.removeEventListener(eventName, handler)
    };
  },
  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},
  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      var listener = handlers[handler];
      if (!listener || !prefersReducedMotionMedia) {
        return;
      }
      removeChangeListener(listener);
    }
    return;
  }
};
/* harmony default export */ var exports_AccessibilityInfo = (AccessibilityInfo);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(6765);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 45 modules
var Dialog = __webpack_require__(310);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(41538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/helpers.js
var CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY = "?preset=3:2-md&presetScale=3/4service=lightbox&dpr=1", CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL = "?preset=3:2-sm&presetScale=1/8&service=lightbox&dpr=1";


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/Lightbox.js














var Lightbox = function(param) {
    var analyticsName = param.analyticsName, photoUrls = param.photoUrls, isOpen = param.isOpen, handleClose = param.handleClose, mobileTitle = param.mobileTitle, footer = param.footer, selectedPhotoIndex = param.selectedPhotoIndex;
    var ref = (0,useWindowDimensions/* default */.Z)(), windowWidth = ref.width, windowHeight = ref.height, photoRefs = (0,react.useRef)([]), ref1 = (0,react.useState)(selectedPhotoIndex || 0), primaryPhotoIndex = ref1[0], setPrimaryPhotoIndex = ref1[1], containerRef = (0,react.useRef)(null), ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], ref3 = (0,react.useState)(!1), isLandscape = ref3[0], setIsLandscape = ref3[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), lastNavigationSource = (0,react.useRef)(null), primaryPhotoRefs = (0,react.useRef)(photoUrls.map(function(_) {
        return /*#__PURE__*/ (0,react.createRef)();
    })), handleOnPress = function(index) {
        setPrimaryPhotoIndex(index);
    };
    (0,react.useEffect)(function() {
        cjs.isClient && Math.abs(window.orientation) === 90 && setIsLandscape(!0);
    }, []), (0,react.useEffect)(function() {
        selectedPhotoIndex != null && setPrimaryPhotoIndex(selectedPhotoIndex);
    }, [
        selectedPhotoIndex
    ]), (0,react.useEffect)(function() {
        var ref;
        var photoItem = photoRefs.current[primaryPhotoIndex];
        photoItem === null || photoItem === void 0 ? void 0 : photoItem.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        }), ((ref = lastNavigationSource.current) === null || ref === void 0 ? void 0 : ref.source) === "keyboard" && !lastNavigationSource.current.keyboardActivated && (photoItem === null || photoItem === void 0 ? void 0 : photoItem.focus());
    }, [
        primaryPhotoIndex
    ]);
    var handleRight = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex + 1;
        return newIndex >= photoUrls.length && (newIndex = 0), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]), handleLeft = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex - 1;
        return newIndex < 0 && (newIndex = photoUrls.length - 1), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]);
    (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                var touches = evt.nativeEvent.touches;
                touches && touches.length < 2 && offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var currentImageIndex = primaryPhotoIndex, threshold = windowWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photoUrls.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * windowWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: !cjs.isWeb
                }).start(function() {
                    currentOffset.current = -newIndex * windowWidth, setPrimaryPhotoIndex(newIndex), exports_AccessibilityInfo.announceForAccessibility("Image ".concat(newIndex + 1));
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: !cjs.isWeb
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex,
        photoUrls.length
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-primaryPhotoIndex * windowWidth), currentOffset.current = -primaryPhotoIndex * windowWidth;
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex
    ]);
    var handleKeyDownEvents = (0,react.useCallback)(function(e) {
        (0,_instanceof/* default */.Z)(e, KeyboardEvent) && (e.key === "ArrowRight" ? lastNavigationSource.current = handleRight("keyboard") : e.key === "ArrowLeft" ? lastNavigationSource.current = handleLeft("keyboard") : e.key === "Escape" && handleClose());
    }, [
        handleClose,
        handleLeft,
        handleRight
    ]), handleChevronPress = (0,react.useCallback)(function(direction) {
        return function(event) {
            var keyboardActivated = !1;
            "nativeEvent" in event && (0,_instanceof/* default */.Z)(event.nativeEvent, KeyboardEvent) ? keyboardActivated = !0 : event.type === "click" && (keyboardActivated = !1), lastNavigationSource.current = direction === "left" ? handleLeft("button", keyboardActivated) : handleRight("button", keyboardActivated);
        };
    }, [
        handleLeft,
        handleRight
    ]);
    (0,react.useEffect)(function() {
        return cjs.isWeb && document.addEventListener("keydown", handleKeyDownEvents), function() {
            cjs.isWeb && document.removeEventListener("keydown", handleKeyDownEvents);
        };
    }, [
        handleKeyDownEvents
    ]), (0,react.useEffect)(function() {
        windowWidth > windowHeight ? setIsLandscape(!0) : setIsLandscape(!1);
    }, [
        windowHeight,
        windowWidth
    ]);
    var renderImages = function() {
        return photoUrls.map(function(photo, index) {
            return index >= primaryPhotoIndex - 2 && index <= primaryPhotoIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": index !== primaryPhotoIndex,
                flexGrow: 1,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: "Current primary photograph in lightbox",
                    source: {
                        uri: "".concat(photoUrls[index]).concat(CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY)
                    },
                    resizeMode: "contain",
                    height: "100%",
                    width: "100%",
                    mb: "$10x",
                    ref: primaryPhotoRefs.current[index],
                    enableZoom: !0
                })
            }, "main-photos-".concat(index)) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": !0
            }, "main-photo-empty-".concat(index));
        });
    }, ref4 = (0,cjs.useMedia)(), largerThanSM = ref4.largerThanSM, smallerThanMD = ref4.smallerThanMD;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, {
                    animation: "accelerateDecelerateFastest",
                    opacity: 0.5,
                    enterStyle: {
                        opacity: 0
                    },
                    exitStyle: {
                        opacity: 0
                    }
                }, "overlay"),
                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.Vq.Content, {
                    bordered: !0,
                    elevate: !0,
                    animateOnly: [
                        "transform",
                        "opacity"
                    ],
                    animation: [
                        "accelerateDecelerateFastest",
                        {
                            opacity: {
                                overshootClamping: !0
                            }
                        }
                    ],
                    enterStyle: {
                        x: 0,
                        y: -20,
                        opacity: 0,
                        scale: 0.9
                    },
                    exitStyle: {
                        x: 0,
                        y: 10,
                        opacity: 0,
                        scale: 0.95
                    },
                    height: "100%",
                    width: "100%",
                    backgroundColor: "$backgroundInversePureBlack",
                    flexDirection: "column",
                    $smallerThanMD: {
                        justifyContent: "center"
                    },
                    px: 0,
                    focusStyle: {
                        borderColor: "$backgroundInversePureBlack"
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Title */.Vq.Title, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onKeyDown: handleKeyDownEvents,
                            $smallerThanMD: {
                                flexDirection: "row-reverse"
                            },
                            width: "100%",
                            "data-testid": "lightbox-content",
                            mt: isLandscape && !cjs.isWeb ? "$20x" : null,
                            $largerThanSM: {
                                px: "$20x"
                            },
                            px: "$10x",
                            display: "flex",
                            alignItems: "center",
                            mb: "$8x",
                            children: [
                                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    color: "$contentInversePrimary",
                                    "data-testid": "photo-count",
                                    width: 64,
                                    $largerThanSM: {
                                        textAlign: "left"
                                    },
                                    textAlign: "right",
                                    children: [
                                        primaryPhotoIndex + 1,
                                        " of ",
                                        photoUrls.length
                                    ]
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    flex: 1,
                                    justifyContent: "center",
                                    children: smallerThanMD && mobileTitle
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        $smallerThanMD: {
                                            width: "$64x"
                                        },
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                                analyticsName: "desktop-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                $largerThanSM: {
                                                    display: "flex"
                                                }
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                analyticsName: "mobile-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "flex"
                                                },
                                                $largerThanSM: {
                                                    display: "none"
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(cjs.View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: "100%"
                        }, panResponder && panResponder.panHandlers), {
                            ref: carouselRef,
                            "aria-label": "Image Carousel, showing image ".concat(primaryPhotoIndex + 1, " of ").concat(photoUrls.length),
                            flex: 1,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                ref: containerRef,
                                height: "100%",
                                justifyContent: "center",
                                alignContent: "center",
                                aspectRatio: "3/2",
                                "data-testid": "lightbox-swipeable",
                                children: [
                                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                                        style: {
                                            flexDirection: "row",
                                            width: windowWidth * photoUrls.length,
                                            transform: [
                                                {
                                                    translateX: offsetX
                                                }
                                            ],
                                            marginBottom: 5,
                                            flex: 1
                                        },
                                        children: renderImages()
                                    }),
                                    cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                "data-testid": "lightbox-back-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-back-button"),
                                                size: "medium",
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    left: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                onPress: handleChevronPress("left"),
                                                position: "absolute",
                                                left: 0,
                                                ml: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                                "data-testid": "lightbox-forward-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-forward-button"),
                                                size: "medium",
                                                onPress: handleChevronPress("right"),
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    right: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                position: "absolute",
                                                right: 0,
                                                mr: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            })
                                        ]
                                    }),
                                    largerThanSM && cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
                                            horizontal: !0,
                                            showsHorizontalScrollIndicator: !1,
                                            children: photoUrls === null || photoUrls === void 0 ? void 0 : photoUrls.map(function(photo, index) {
                                                return /* @__PURE__ */ (0,jsx_runtime.jsx)(CarouselPhoto, {
                                                    handleOnPress: handleOnPress,
                                                    photoUrl: photo,
                                                    index: index,
                                                    primaryPhotoIndex: primaryPhotoIndex,
                                                    isPrimary: index === primaryPhotoIndex,
                                                    photoRefs: photoRefs
                                                }, index);
                                            })
                                        })
                                    }),
                                    cjs.isWeb && largerThanSM && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        p: "$8x",
                                        width: "100%",
                                        children: footer
                                    })
                                ]
                            })
                        }))
                    ]
                }, "content")
            ]
        })
    });
};
Lightbox.displayName = "Lightbox";
var CarouselPhoto = function(param) {
    var handleOnPress = param.handleOnPress, photoUrl = param.photoUrl, index = param.index, isPrimary = param.isPrimary, photoRefs = param.photoRefs;
    var onPress = (0,react.useCallback)(function() {
        handleOnPress(index);
    }, [
        handleOnPress,
        index
    ]), IMG_CONTAINER_HEIGHT = 65, IMG_CONTAINER_WIDTH = 99, CONTAINER_HEIGHT = 73, photo = "".concat(photoUrl).concat(CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL), handleRef = function(el) {
        el && photoRefs.current && (photoRefs.current[index] = el);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(PressableBox/* PressableBox */.K, {
        analyticsName: "lightbox-photo-item-".concat(index),
        "aria-label": "Lightbox carousel photo ".concat(index + 1),
        borderColor: isPrimary ? "$borderTertiary" : "$backgroundInversePureBlack",
        borderWidth: "$2x",
        height: CONTAINER_HEIGHT,
        $smallerThanMD: {
            display: "none"
        },
        onPress: onPress,
        "data-testid": "photo-item-".concat(index),
        px: 0,
        ref: handleRef,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "carousel photograph ".concat(index + 1),
            source: {
                uri: photo
            },
            resizeMode: "cover",
            height: IMG_CONTAINER_HEIGHT,
            width: IMG_CONTAINER_WIDTH
        })
    });
};



/***/ }),

/***/ 7609:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N7": function() { return /* binding */ observe; },
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, default, defaultFallbackInView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 96832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ Themed; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(30236);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 6 modules
var chakra_ui_system_esm = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/DatePicker/ReactDatesStyles.mjs
var ReactDatesStyles = __webpack_require__(94339);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Spritesheet.mjs + 138 modules
var Spritesheet = __webpack_require__(9526);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/styles/FontFace.mjs
function cov_28e88htlke() {
  var path = "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx";
  var hash = "39acc2af239b40568310f2c203694ecb7cea6bc4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 34
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 99,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 34
          },
          end: {
            line: 10,
            column: 35
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 99,
            column: 4
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39acc2af239b40568310f2c203694ecb7cea6bc4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28e88htlke = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28e88htlke();



/**
 * Globally defined font definitions for the theme.
 * Currently font are also defined in packages/primer/stylesheets/market/variables.less -
 * this will ultimately replace the less file.
 */
cov_28e88htlke().s[0]++;
var FontFace = function FontFace() {
  cov_28e88htlke().f[0]++;
  cov_28e88htlke().s[1]++;
  return /*#__PURE__*/react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: "\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Graphik-Regular'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 500;\n        src: local('Graphik-Medium'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Graphik-Semibold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Semibold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 800;\n        src: local('Graphik-Bold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Noto-Mono';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Noto-Mono-Regular'), local('Noto-Mono'),\n          url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n\n      body,\n      input,\n      select {\n        text-rendering: optimizeLegibility;\n\n        // Base font size for all breakpoints\n        font: 400 16px / 1.7 'Graphik', sans-serif;\n        color: var(--colors-neutrals100);\n      }\n    "
  });
};
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/styles/Reset.mjs
var Reset = __webpack_require__(75590);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/index.mjs + 2 modules
var es_theme = __webpack_require__(91567);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ThemeOverrideExpiredBanner.mjs + 3 modules
var ThemeOverrideExpiredBanner = __webpack_require__(33651);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/ODTheme.mjs






var _excluded = ["children"];
function cov_2ijo9jc43y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx";
  var hash = "706ff77feed03f8de73212117c1fb36840db55a4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 45
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 76
        }
      },
      "2": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 38
        }
      },
      "6": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 45
          },
          end: {
            line: 16,
            column: 46
          }
        },
        loc: {
          start: {
            line: 16,
            column: 73
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 18,
            column: 62
          }
        }, {
          start: {
            line: 18,
            column: 65
          },
          end: {
            line: 18,
            column: 76
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 37
          }
        }, {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 47
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "706ff77feed03f8de73212117c1fb36840db55a4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ijo9jc43y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ijo9jc43y();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








// This uses an SVG spritesheet which must be injected once per page.
// The approach is detailed [here](https://css-tricks.com/svg-sprites-use-better-icon-fonts/)
// Some of the pros and cons of this approach are detailed [here](https://opendoor.slack.com/archives/C023V2C14BX/p1628281932070100)
cov_2ijo9jc43y().s[0]++;
var Themed = function Themed(_ref) {
  var _ref2;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2ijo9jc43y().f[0]++;
  // Determines the base theme to apply to the component library
  var baseThemeName = (cov_2ijo9jc43y().s[1]++, 'baseTheme' in props ? (cov_2ijo9jc43y().b[0][0]++, props.baseTheme) : (cov_2ijo9jc43y().b[0][1]++, props.theme));
  var theme = (cov_2ijo9jc43y().s[2]++, es_theme/* THEME_MAP */.v[(_ref2 = (cov_2ijo9jc43y().b[1][0]++, baseThemeName)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2ijo9jc43y().b[1][1]++, 'eero')]);

  // Applies any theme overrides to the base theme
  cov_2ijo9jc43y().s[3]++;
  if ('baseTheme' in props) {
    cov_2ijo9jc43y().b[2][0]++;
    cov_2ijo9jc43y().s[4]++;
    theme = cloneDeep(theme);
    cov_2ijo9jc43y().s[5]++;
    mergeWith(theme, props.overrides);
  } else {
    cov_2ijo9jc43y().b[2][1]++;
  }
  cov_2ijo9jc43y().s[6]++;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Spritesheet/* default */.Z, null), /*#__PURE__*/react.createElement(chakra_ui_system_esm/* ThemeProvider */.f6, _extends({}, props, {
    theme: theme
  }), /*#__PURE__*/react.createElement(FontFace, null), /*#__PURE__*/react.createElement(Reset/* Reset */.A, null), /*#__PURE__*/react.createElement(ReactDatesStyles/* ReactDatesStyles */.i, null), children, /*#__PURE__*/react.createElement(ThemeOverrideExpiredBanner/* ThemeOverrideExpiredBanner */.C, {
    baseTheme: baseThemeName,
    launchDateString: props['launchDateString']
  })));
};

/***/ }),

/***/ 64260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony exports centsToCurrencyString, centsToPrettyCurrencyString, fractionToPercentString, abbreviationToStateString */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56977);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54678);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15306);








var formatCurrency = function formatCurrency(centsValue) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var decimalPlaces = roundToCents ? 2 : 0;
  var parsedNum = centsValue.toString().replace(/\$|,/g, '');
  var rounded = parseFloat(parsedNum).toFixed(decimalPlaces);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(Number(rounded)) ? 0 : Number(rounded));
};
var centsToCurrencyString = function centsToCurrencyString(valueCents) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return formatCurrency(valueCents / 100, roundToCents);
};
var addSuffix = function addSuffix(dollars, suffix) {
  return "".concat(dollars.toLocaleString('en-US', {
    maximumFractionDigits: suffix === 'k' ? 0 : 1
  })).concat(suffix);
};

// converts currency cents from 24000000 to 240K, 240000000 to 2.4M and
// aspirationally will also handle billions correctly
function centsToPrettyCurrencyString(valueCents) {
  var showDollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var valueInDollars = Math.round(valueCents / 100);
  var absoluteValue = Math.abs(valueInDollars);
  var showNegative = valueCents < 0 ? '-' : '';
  var isBillions = absoluteValue >= 1000000000;
  var isMillions = absoluteValue >= 1000000;
  var isThousands = absoluteValue >= 1000;
  var suffix = isBillions ? 'B' : isMillions ? 'M' : isThousands ? 'K' : '';
  var formattedString = "".concat(absoluteValue);
  if (isBillions) {
    formattedString = addSuffix(absoluteValue / 1000000000, suffix);
  } else if (isMillions) {
    formattedString = addSuffix(absoluteValue / 1000000, suffix);
  } else if (isThousands) {
    formattedString = addSuffix(Math.round(absoluteValue / 1000), suffix);
  }
  return "".concat(showNegative).concat(showDollarSign ? '$' : '').concat(formattedString);
}

/*
TODO: Migrate to use Intl.NumberFormat once typescript is updated
https://v8.dev/features/intl-numberformat#sign
*/
var fractionToPercentString = function fractionToPercentString(valueFraction) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits,
    style: 'percent'
  }).format(valueFraction);
};

// converts state abbreviation to their full name
var abbreviationToStateString = {
  AL: 'alabama',
  AK: 'alaska',
  AZ: 'arizona',
  AR: 'arkansas',
  CA: 'california',
  CO: 'colorado',
  CT: 'connecticut',
  DE: 'delaware',
  FL: 'florida',
  GA: 'georgia',
  HI: 'hawaii',
  ID: 'idaho',
  IL: 'illinois',
  IN: 'indiana',
  IA: 'iowa',
  KS: 'kansas',
  KY: 'kentucky',
  LA: 'louisiana',
  ME: 'maine',
  MD: 'maryland',
  MA: 'massachusetts',
  MI: 'michigan',
  MN: 'minnesota',
  MS: 'mississippi',
  MO: 'missouri',
  MT: 'montana',
  NE: 'nebraska',
  NV: 'nevada',
  NH: 'new_hampshire',
  NJ: 'new_jersey',
  NM: 'new_mexico',
  NY: 'new_york',
  NC: 'north_carolina',
  ND: 'north_dakota',
  OH: 'ohio',
  OK: 'oklahoma',
  OR: 'oregon',
  PA: 'pennsylvania',
  RI: 'rhode_island',
  SC: 'south_carolina',
  SD: 'south_dakota',
  TN: 'tennessee',
  TX: 'texas',
  UT: 'utah',
  VT: 'vermont',
  VA: 'virginia',
  WA: 'washington',
  WV: 'west_virginia',
  WI: 'wisconsin',
  WY: 'wyoming'
};

/***/ }),

/***/ 33733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.mjs
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};


//# sourceMappingURL=defaultAttributes.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.mjs
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */




const createReactComponent = (type, iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref) => (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes[type],
        width: size,
        height: size,
        className: [`tabler-icon`, `tabler-icon-${iconName}`, className].join(" "),
        ...type === "filled" ? {
          fill: color
        } : {
          strokeWidth: stroke,
          stroke: color
        },
        ...rest
      },
      [
        title && (0,react.createElement)("title", { key: "svg-title" }, title),
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    )
  );
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.mjs.map


/***/ }),

/***/ 66172:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconShieldLock; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 12l0 2.5", "key": "svg-2" }]];
const IconShieldLock = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "shield-lock", "ShieldLock", __iconNode);


//# sourceMappingURL=IconShieldLock.mjs.map


/***/ }),

/***/ 29513:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconShieldLockFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z", "key": "svg-0" }]];
const IconShieldLockFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "shield-lock-filled", "ShieldLockFilled", __iconNode);


//# sourceMappingURL=IconShieldLockFilled.mjs.map


/***/ }),

/***/ 70781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTruck; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5", "key": "svg-2" }]];
const IconTruck = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "truck", "Truck", __iconNode);


//# sourceMappingURL=IconTruck.mjs.map


/***/ }),

/***/ 77178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTruckFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783 .378l.074 .108l3 5l.055 .103l.04 .107l.029 .109l.016 .11l.003 .085v6a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m.434 -9h-3.434v3h5.234z", "key": "svg-0" }]];
const IconTruckFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "truck-filled", "TruckFilled", __iconNode);


//# sourceMappingURL=IconTruckFilled.mjs.map


/***/ })

}]);